// import { useMsal } from "@azure/msal-react";

import { IPublicClientApplication } from "@azure/msal-browser";

// // After login, acquire token
// const getToken = async () => {
//   const { instance } = useMsal();

//   try {
//     const response = await instance.acquireTokenSilent(tokenRequest);
//     console.log("Access token:", response.accessToken);
//     return response.accessToken;
//   } catch (error) {
//     // Fallback to interactive method
//     return instance.acquireTokenPopup(tokenRequest);
//   }
// };

export const logOut = (
  instance: IPublicClientApplication,
  loginHint?: string
) => {
  const authority = instance.getConfiguration().auth.authority;
  const clientId = instance.getConfiguration().auth.clientId;
  const postLogoutRedirectUri = encodeURIComponent(
    window.location.origin + "/logged-out"
  );

  // Build login_hint parameter for seamless logout if provided
  const loginHintParam = loginHint
    ? `&login_hint=${encodeURIComponent(loginHint)}`
    : "";

  // This forces B2C to clear the session
  const logoutUrl = `${authority}/oauth2/v2.0/logout?post_logout_redirect_uri=${postLogoutRedirectUri}&client_id=${clientId}${loginHintParam}`;

  window.location.href = logoutUrl;
};
